import { Link } from 'react-router-dom';

import logo from '../../image/logo.png';


export default function NotFoundPage() {
    return (
        <div className='bg-white h-full w-full absolute'>
            <div className='mt-48 grid justify-center'>

                <img src={logo} alt='logoLivepoint' className='w-32 h-32' />

                <div>
                    <p className='text-center align-middle text-5xl text-blue-400'>
                        <h3>Ooups, cette page n'existe pas.</h3>
                        <Link to="/"><br /> Go to Home </Link>
                    </p>
                </div>
            </div>
        </div>
    )
}